import { ObjectValues } from 'types';

export const DESKTOP_APP_PLATFORM = {
  WINDOWS: 'windows',
  MACOS: 'macos',
  LINUX: 'linux',
} as const;

export type DesktopAppPlatform = ObjectValues<typeof DESKTOP_APP_PLATFORM>;

export type DesktopAppDownload = {
  platform: DesktopAppPlatform;
  url: string;
};

export type DesktopAppVersion = {
  version: string;
  releasedAt: string;
  downloads: DesktopAppDownload[];
};

export type DesktopAppDownloads = {
  versions: DesktopAppVersion[];
};
